import { EmailAddress, IEmailAddress } from '@app/models/EmailAddress'
import { EmailType } from '@app/models/enums'
import { IGlobalConfigurationState } from '@app/store/modules/global'
import { bindFunctions } from '@app/utils/class'
import { humanize } from '@app/utils/formatting'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { List } from 'immutable'
import * as React from 'react'
import { Button, Input, InputGroup, InputGroupAddon } from 'reactstrap'

interface IComponentProps {
  dataSource?: List<IEmailAddress>
  onChange: (e: any) => void
}

interface IComponentState {
  emailItems: List<IEmailAddress>
}

export default class EmailAddressList extends React.PureComponent<
  IComponentProps & IGlobalConfigurationState,
  IComponentState
> {
  public constructor(props: any) {
    super(props)

    this.state = {
      emailItems: this.props.dataSource || List<IEmailAddress>(),
    }

    bindFunctions(this)
  }

  public render() {
    return (
      <div className='d-flex flex-column'>
        <Button
          size='sm'
          className='mt-1 mb-2 mr-auto'
          onClick={() => this._addEmailAddressItem()}
          color='primary'
        >
          <FontAwesomeIcon icon={['fal', 'plus']} fixedWidth />
          <span>Email</span>
        </Button>
        {this._renderEmailAddressItems()}
      </div>
    )
  }

  private _renderEmailAddressItems() {
    return this.state.emailItems
      .toArray()
      .map((p: IEmailAddress, i: number) => {
        return (
          <div key={`email-${i}`} className='d-flex flex-row mt-2'>
            <Input
              type='select'
              className='mr-2'
              value={p.type}
              onChange={(e) => this._editEmailAddressType(e.target.value, i)}
            >
              {this.props.configuration.emailTypes
                .map((c, index) => (
                  <option key={`emailType-${index}`} value={c}>
                    {humanize(c)}
                  </option>
                ))
                .toJS()}
            </Input>

            <InputGroup>
              <Input
                placeholder='joe@example.com'
                type='email'
                className='form-control'
                value={p.emailAddress}
                onChange={(e) => this._editEmailAddress(e.target.value, i)}
                required
              />
              <InputGroupAddon addonType='append'>
                <Button
                  className='align-self-center'
                  color='danger'
                  onClick={() => this._removeEmailAddressItem(i)}
                >
                  <FontAwesomeIcon icon={['fal', 'trash']} fixedWidth />
                </Button>
              </InputGroupAddon>
            </InputGroup>
          </div>
        )
      })
  }

  private _removeEmailAddressItem(index: number) {
    const items = this.state.emailItems.remove(index) as List<EmailAddress>

    this.props.onChange(items)

    this.setState({
      emailItems: items,
    })
  }

  private _addEmailAddressItem() {
    let items = this.state.emailItems
    items = items.push(
      new EmailAddress({
        emailAddress: '',
        type: EmailType.Primary,
      }),
    )

    this.props.onChange(items)

    this.setState({
      emailItems: items,
    })
  }

  private _editEmailAddress(value: string, index: number) {
    const items = this.state.emailItems.setIn(
      [index, 'emailAddress'],
      value,
    ) as List<EmailAddress>

    this.props.onChange(items)

    this.setState({
      emailItems: items,
    })
  }

  private _editEmailAddressType(value: string, index: number) {
    const items = this.state.emailItems.setIn([index, 'type'], value) as List<
      EmailAddress
    >
    this.props.onChange(items)

    this.setState({
      emailItems: items,
    })
  }
}
